class ContactUs {
    constructor() {
      this.init();
    }
  
    clickEVent = () => {
      let chat = document.querySelector('.chat-js');
      chat?.addEventListener('click', (e) => {
        // Chat click event
      })
    }
  
    init = () => {
      this.clickEVent();
    }
  }
  
  new ContactUs;